module.exports = __webpack_public_path__ + "static/media/thumbnail.975e61cf.jpg";